import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client";

const getCampaigns = (clinicid, params = {}) => {
    return axios.get(`${API_URL}/clinics/${clinicid}/campaigns`, { params });
};

export default {
    getCampaigns
};
